@use 'src/global/variables' as var;


c-form-input {
    input[type=text] {
      padding: 10px !important;
      margin:10px 0 !important;
      width: 85% !important;
      border-radius: 10px !important;
    }

    label,
    input[type=text] {
      margin-left: var.$margin !important;
    }

    .info {
      margin-left: var.$margin !important;
      margin-top: -20px !important;
      color: darkgrey;
      font-size: smaller !important;
    }
}